// components
import Spinner from "components/atoms/Spinner/Spinner";
import EditRejectPageTemplate, { EditRejectPageTemplateProps } from "components/organisms/EditRejectPageTemplate/EditRejectPageTemplate";

// constants
import { EDIT_MONTHLY_REIMBURSMENT as Constants, FILE_UPLOAD_CONSTANT } from "constants/global";

// hook
import { useMonthlyReimbursementEditPage } from "containers/MonthlyDeclaration/EditReimbursement/useMonthlyReimbursementEditPage";

const MonthlyReimbursementEditPage = (): JSX.Element => {
	const props = useMonthlyReimbursementEditPage();

	const MonthlyReimbursementEditPageProps: EditRejectPageTemplateProps = {
		stepsInfo: Constants.STEPS_INFO,
		headTitle: Constants.HEAD_TITLE,
		pageTitle: Constants.PAGE_TITLE,
		pageSubTitle: Constants.PAGE_SUBTITLE,
		uploadFileTypes: FILE_UPLOAD_CONSTANT.EDIT_MONTHLY_REIMBURSMENT_FILETYPE,
		operationType: "edit",
		pageGoBack: props.goBack,
		...props
	};

	return props.loadingWithoutData ? <Spinner /> : <EditRejectPageTemplate {...MonthlyReimbursementEditPageProps} />;
};

export default MonthlyReimbursementEditPage;
